import moment from 'moment';
import { EquipmentItem } from "../../entities";
import { getAuthorRefForGateway, getAuthorRefFromGateway } from './ParsingUtils';
export default class EquipmentItemParser {
    static toGateway(equipmentItem, app) {
        return {
            Id: equipmentItem._id,
            CreatedTimestamp: moment(equipmentItem.createdTimestamp).utc().toISOString(),
            Author: getAuthorRefForGateway(equipmentItem.author, app),
            EquipmentList: equipmentItem.list,
            Name: equipmentItem.name,
            ItemData: equipmentItem.itemData,
            ContentTypeConfig: equipmentItem.contentTypeConfig,
            Predecessor: equipmentItem.predecessor,
            Deleted: equipmentItem.deleted,
        };
    }
    static fromGateway(gatewayEquipmentItem, app) {
        const equipmentItem = new EquipmentItem({
            name: gatewayEquipmentItem.Name,
            list: gatewayEquipmentItem.EquipmentList,
            author: getAuthorRefFromGateway(gatewayEquipmentItem.Author, app),
        });
        equipmentItem.itemData = gatewayEquipmentItem.ItemData;
        equipmentItem.contentTypeConfig = gatewayEquipmentItem.ContentTypeConfig;
        equipmentItem.predecessor = gatewayEquipmentItem.Predecessor;
        equipmentItem.deleted = gatewayEquipmentItem.Deleted;
        Object.assign(equipmentItem, {
            _id: gatewayEquipmentItem.Id,
            createdTimestamp: gatewayEquipmentItem.CreatedTimestamp,
        });
        return equipmentItem;
    }
}
//# sourceMappingURL=EquipmentItemParser.js.map